import { useState, useEffect } from "react";
import SMHIWarning from "./SMHIWarning";
import axios from "axios";
import LocationCheck from "./SettingsComponents/LocationCheck.js";
import StandardSubSettings from "./SettingsComponents/StandardSubSettings";

import { Typography } from "antd";

const SMHIWarnings = ({ isMobile, tileColor, apiAdd, settings, setHaveNewData }) => {
  const localData = StandardSubSettings(settings, "SMHIWarning");

  const [alertData, setAlertData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [initial, setInitial] = useState(true);

  async function getAPI() {
      const apiFromServer = await axios(
          `https://opendata-download-warnings.smhi.se/api/version/2/alerts.json`
      );
      setAlertData(apiFromServer.data);
  }

  useEffect(() => {
    getAPI();
    const interval = setInterval(getAPI, 65000);
    return () => clearInterval(interval);
  }, []);

  let valueArray = [];

  function SMHIHaveNewDataCallback(value) {
    valueArray.push(value);

    if (valueArray.includes(true)) {
      setHaveNewData(true);
    } else {
      setHaveNewData(false);
    }
  }

  const sendInfo = () => {
    if (alertData.alert) setInitial(false);

    console.log("jahopp");
    if (alertData.alert) {
      alertData.alert.forEach((value, index) => {
        const dateFormated = value.code[1]
          .replace("latest_update ", "")
          .replaceAll("-", "")
          .replaceAll("T", "")
          .replaceAll(":", "")
          .replace("+", "");
        console.log("date on smhi: " + dateFormated);
        if (
          SettingsCheck(value.info.eventCode[4].value) &&
          LocationCheck("SMHI", value.info.headline, localData.location)
        )
          setFinalData((finalData) => [
            ...finalData,
            {
              idArray: 0,
              headline: value.info.headline,
              event: value.info.event,
              desc: value.info.description,
              severity: value.info.severity,
              color: value.info.eventCode[4].value,
              date: dateFormated,
              callback: SMHIHaveNewDataCallback,
              settings: { settings },
            },
          ]);
      });
    }
  };

  useEffect(() => {
    if (isMobile === "true") apiAdd(finalData);
  }, [finalData]);

  useEffect(() => {
    if (initial && isMobile === "true") sendInfo();
  }, [alertData]);

  // Filters out data based on settings
  function SettingsCheck(color) {
    if (color === "#75d5ff" && !localData.risk) return false;
    else if (color === "#ab56ac" && !localData.brandrisk) return false;
    else if (color === "#b5e5af" && !localData.highTemp) return false;
    else return true;
  }


  var empty = true;

  const apiData =
      alertData.alert &&
      alertData.alert.map((value, index) => {
        if (
            SettingsCheck(value.info.eventCode[4].value) &&
            LocationCheck("SMHI", value.info.headline, localData.location)
        ) {
          empty = false;
          return (
              <>
                {isMobile === "true" ? (
                    <></>
                ) : (
                    <SMHIWarning
                        key={index}
                        headline={value.info.headline}
                        event={value.info.event}
                        desc={value.info.description}
                        severity={value.info.severity}
                        color={value.info.eventCode[4].value}
                        time={value.sent}
                        callback={SMHIHaveNewDataCallback}
                        settings={settings}
                    />
                )}
              </>
          );
        }
      });

  return (
    <>
      {empty ? (
        <>
          {isMobile === "true" ? (
            <></>
          ) : (
            <>
              <Typography.Title level={5} className="tileHeader">
                Det finns inga varningar att visa
              </Typography.Title>
            </>
          )}
        </>
      ) : (
        <>{apiData}</>
      )}
    </>
  );
};

export default SMHIWarnings;
